import { redirect } from 'react-router-dom'

import { FlowType } from '@cash-web/protos/squareup/cash/plasma/flows/FlowProto.pb'
import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const stocksClientRoutes = [
  {
    id: 'stocks-sell',
    trackingName: 'Stocks Sell',
    path: 'web/view/stocks/sell/:investmentEntityToken',
    lazy: async () => ({
      Component: (await import('@cash-web/account-stocks-feature-main')).StocksSellFlow,
    }),
  },
  {
    id: 'stocks-buy',
    trackingName: 'Stocks Buy',
    path: 'web/view/investing/buy/:investmentEntityToken',
    lazy: async () => ({
      Component: (await import('@cash-web/account-stocks-feature-main')).InvestingBuyFlow,
    }),
  },
  {
    id: 'stocks-activity',
    trackingName: 'Stocks View All Activity',
    path: 'web/view/investing/activity/:investmentEntityToken',
    lazy: async () => ({
      Component: (await import('@cash-web/account-stocks-feature-main')).InvestingActivity,
    }),
  },
  {
    id: 'round-ups-onboarding',
    trackingName: 'Round Ups Onboarding',
    path: 'dl/view/investing/round_ups_onboarding',
    lazy: async () => ({
      Component: (await import('@cash-web/account-stocks-feature-main')).JourneyRoundUpsOnboarding,
      props: { isEditing: false },
    }),
  },
  {
    id: 'round-ups',
    trackingName: 'Round Ups',
    path: 'dl/view/investing/round_ups',
    loader: async () => {
      throw redirect(`/dl/flow/${FlowType.PIGGYBANK_SAVINGS_ROUND_UP}`)
    },
  },
  {
    id: 'round-ups-failed-confirmation',
    trackingName: 'Round Ups Failed Confirmation',
    path: 'dl/view/investing/round_ups_failed_confirmation',
    handle: {
      unsupported: true,
    },
  },
  {
    id: 'round-ups-skipped-confirmation',
    trackingName: 'Round Ups Skipped Confirmation',
    path: 'dl/view/investing/round_ups_skipped_confirmation',
    handle: {
      unsupported: true,
    },
  },
  {
    id: 'roundup-aggregated-transactions',
    trackingName: 'Roundup Aggregated Transactions',
    path: 'dl/view/investing/roundup_aggregated_transactions/:payment_token',
    handle: {
      unsupported: true,
    },
  },
] as const satisfies JourneyRoute[]
